const ResetModal = function () {
  this.requestUserMeta.hideModal()
  this.requestUserMeta.resetForm()
}

export default ResetModal
